import type {SessionResponse} from "@project/sdk/security";
import type {z} from "zod";

import {z as zod} from "zod";

const sessionUserSchema = zod.strictObject({
  displayName: zod.string().min(1),
  email: zod.email().optional(),
  id: zod.string().min(1),
});

export const authSessionSchema = zod.discriminatedUnion("authenticated", [
  zod.strictObject({authenticated: zod.literal(false), user: zod.null()}),
  zod.strictObject({authenticated: zod.literal(true), user: sessionUserSchema}),
]) satisfies z.ZodType<SessionResponse>;
